// import globalConfig from "../config/index";

// const apiUrl = globalConfig.server;
const apiUrl = "https://api.healthforce.cc";
export default {
  // upload
  upload: `${apiUrl}/api/file/upload`, // 上传文件
  directoryBase: `${apiUrl}/api/folder`, // 基础文件夹
  getDirectoryList: `${apiUrl}/api/folder/tree`, // 获取文件夹列表
  directoryDetail: `${apiUrl}/api/folder/{id}`, // 文件夹详情
  fileDetail: `${apiUrl}/api/file/{id}`, // 文件详情
  // city
  getCityList: `${apiUrl}/api/region/cascader`, // 获取城市信息
  // sms
  sendSms: `${apiUrl}/api/sms/send`, // 发送短信
  // 租户
  baseTenant: `${apiUrl}/api/tenant`, // 租户基础信息
  getMyTenants: `${apiUrl}/api/tenant/myData`, // 获取店铺信息
  // skcuser新保云平台用户相关服务
  skcuserValidate: `${apiUrl}/api/skcuser/validate`, // 注册新增验证
  skcRegister: `${apiUrl}/api/skcuser/register`, // 注册

  // user
  verify: `${apiUrl}/api/auth/verify`, // 验证码验证
  login: `${apiUrl}/api/auth/login`, // 用户登入
  logout: `${apiUrl}/api/auth/logout`, // 用户登出
  getLoginInfo: `${apiUrl}/api/auth/loginInfo`, // 获取登入信息

  baseUser: `${apiUrl}/api/user`, // 用户基础接口
  deleteUser: `${apiUrl}/api/user/{id}`, // 删除用户

  changeUserStatus: `${apiUrl}/api/user/changeStatus`, // 修改用户状态
  resetUserPwd: `${apiUrl}/api/user/resetPwd`, // 重置用户密码
  getUserDetail: `${apiUrl}/api/user/{id}`, // 获取用户详情
  getSKCUserDetail: `${apiUrl}/api/skcuser/findDetail`, // 获取新保云用户详情
  getUserPage: `${apiUrl}/api/user/query`, // 分页获取用户列表
  getUserOwnData: `${apiUrl}/api/user/ownData`, // 获取用户拥有数据
  grantUserData: `${apiUrl}/api/user/grantData`, // 授权用户数据范围

  getUserOwnRole: `${apiUrl}/api/user/ownRole`, // 获取用户拥有角色
  grantUserRole: `${apiUrl}/api/user/grantRole`, // 授权用户角色

  changePassWord: `${apiUrl}/api/skcuser/modfiypwd`, // 修改密码
  skcuser: `${apiUrl}/api/skcuser`, // 修改密码

  // app
  baseApp: `${apiUrl}/api/app`, // 应用基础接口
  deleteApp: `${apiUrl}/api/app/{id}`, // 删除接口

  getAppPage: `${apiUrl}/api/app/query`, // 分页获取应用列表
  getAppList: `${apiUrl}/api/app/list`, // 获取应用列表
  setAppAsDefault: `${apiUrl}/api/app/setAsDefault`, // 设置默认应用
  changeAppStatus: `${apiUrl}/api/app/changeStatus`, // 修改应用状态

  // role
  baseRole: `${apiUrl}/api/role`, // 角色基础接口
  deleteRole: `${apiUrl}/api/role/{id}`, // 角色基础接口
  getRolePage: `${apiUrl}/api/role/query`, // 获取角色分页数据
  getRoleList: `${apiUrl}/api/role/list`, // 获取角色列表
  roleGrantMenu: `${apiUrl}/api/role/grantMenu`, // 角色授权菜单
  roleGrantData: `${apiUrl}/api/role/grantData`, // 角色授权数据
  getRoleOwnMenu: `${apiUrl}/api/role/ownMenu`, // 获取角色拥有菜单Id集合
  getRoleOwnData: `${apiUrl}/api/role/ownData`, // 获取角色拥有数据权限Id集合

  // log
  getExLogPage: `${apiUrl}/api/exLog/query`, // 获取异常日志分页数据
  getOpLogPage: `${apiUrl}/api/opLog/query`, // 获取操作日志分页数据
  getVisLogPage: `${apiUrl}/api/visLog/query`, // 获取访问日志分页数据

  // menu
  menuChange: `${apiUrl}/api/menu/change`, // 菜单切换
  treeForGrant: `${apiUrl}/api/menu/treeForGrant`, // 获取系统菜单树，用于给角色授权时选择
  getMenuList: `${apiUrl}/api/menu/query`, // 系统菜单列表（树表）
  baseMenu: `${apiUrl}/api/menu`, // 新增/编辑menu
  delMenu: `${apiUrl}/api/menu/{id}`, // 删除menu

  // org
  baseOrg: `${apiUrl}/api/org`, // 机构部门基础api
  deleteOrg: `${apiUrl}/api/org/{id}`, // 删除机构部门

  getOrgTree: `${apiUrl}/api/org/tree`, // 获取机构树
  getOrgPage: `${apiUrl}/api/org/query`, // 分页获取机构树
  getOrgList: `${apiUrl}/api/org/list`, // 获取机构列表

  // pos
  basePos: `${apiUrl}/api/pos`, // 职位基础接口
  deletePos: `${apiUrl}/api/pos/{id}`, // 删除职位
  getPosPage: `${apiUrl}/api/pos/query`, // 获取职位分页
  getPosList: `${apiUrl}/api/pos/list`, // 获取职位列表

  // tag
  getTagPage: `${apiUrl}/api/tag/query`, // 获取标签数据
  baseTag: `${apiUrl}/api/tag`, // 新增/编辑标签
  getTagList: `${apiUrl}/api/tag/allList`, // 获取所有标签

  // reserveBaseItem
  baseItem: `${apiUrl}/api/reserveBaseItem`, // 体检项目基础接口
  delBaseItem: `${apiUrl}/api/reserveBaseItem/{id}`, // 删除体检项目
  getBaseItemPage: `${apiUrl}/api/reserveBaseItem/query`, // 分页获取体检项目
  getBaseItemList: `${apiUrl}/api/reserveBaseItem/list`, // 获取所有体检项目

  // baseItemType
  baseItemType: `${apiUrl}/api/reserveBaseItemType`, // 体检类别基础接口
  delBaseItemType: `${apiUrl}/api/reserveBaseItemType/{id}`, // 删除体检类别
  getBaseItemTypePage: `${apiUrl}/api/reserveBaseItemType/query`, // 分页获取体检类别
  getBaseItemTypeList: `${apiUrl}/api/reserveBaseItemType/list`, // 获取所有体检类别
  baseItemUpFile: `${apiUrl}/api/reserveBaseItem/import`, // 上传

  // 机构
  getHospitalPage: `${apiUrl}/api/hospital/query`, // 获取机构列表
  hospitalDetail: `${apiUrl}/api/hospital/{id}`, // 删除/获取机构
  baseHospital: `${apiUrl}/api/hospital`, // 新增/修改机构
  addScheduling: `${apiUrl}/api/hospDate`, // 增加排期
  schedulingDetail: `${apiUrl}/api/hospDate/{id}`, // 获取排期详情
  setScheduling: `${apiUrl}/api/hospDate/setExt`, // 修改排期
  setSchedulingStatus: `${apiUrl}/api/hospDate/status`, // 修改排期状态
  updateOrgSeting: `${apiUrl}/api/orgSeting`, // 修改机构设置
  getOrgSetingDetail: `${apiUrl}/api/orgSeting`, // 获取机构设置详情
  getPhysicalSeting: `${apiUrl}/api/physicalSeting/{departmentType}`, // 获取体检设置详情
  setPhysicalDateExt: `${apiUrl}/api/physicalSeting/setPhysicalDateExt`, // 修改体检科室配置
  setPhysicalDateStatus: `${apiUrl}/api/physicalDetaExt/status`, // 修改排期日期状态

  // 套餐列表
  getPackagePage: `${apiUrl}/api/medicalPackage/query`, // 获取套餐分页数据列表
  packageDetail: `${apiUrl}/api/medicalPackage/{id}`, // 删除/获取套餐详情
  basepackage: `${apiUrl}/api/medicalPackage`, // 新增/更新套餐
  getPackageHospRel: `${apiUrl}/api/packageHospRel/rellist`, // 获取某个套餐下关联机构列表
  operationPackageHospRel: `${apiUrl}/api/packageHospRel`, // 编辑套餐下关联机构列表
  getPackageItems: `${apiUrl}/api/medicalPackage/queryByPackageId`, // 获取套餐下的项目
  updatePackageItem: `${apiUrl}/api/medicalPackage/updatePackageItem`, // 编辑套餐下的项目
  // goods
  baseGoodsCategory: `${apiUrl}/api/goodsCategory`, // 新增/修改商品分类
  goodsCategoryDetail: `${apiUrl}/api/goodsCategory/{id}`, // 删除/获取商品分类
  getGoodsCategoryPage: `${apiUrl}/api/goodsCategory/query`, // 获取商品分类分页
  getGoodsCategoryList: `${apiUrl}/api/goodsCategory/list`, // 获取商品分类
  baseGoods: `${apiUrl}/api/goodsSPU`, // 新增/修改商品
  getGoodsPage: `${apiUrl}/api/goodsSPU/query`, // 获取列表
  getGoodsPricePage: `${apiUrl}/api/goodsSPU/queryDIYGoodsSPU`, // 获取列表(带价格)
  goodsDetail: `${apiUrl}/api/goodsSPU/{id}`, // 删除商品
  onOffshelf: `${apiUrl}/api/goodsSPU/OnOffshelf/{id}`, // 上下架
  getDistributionGoods: `${apiUrl}/api/goodsSPU/queryDistributionGoods`, // 获取分销商品

  // goodsOrder
  getGoodsOrderPage: `${apiUrl}/api/order/query`, // 获取订单列表
  getGoodsOrderdetail: `${apiUrl}/api/order/{id}`, // 获取订单详情
  changeOrderReceiptInfo: `${apiUrl}/api/changeOrderReceiptInfo`, // 获取订单详情
  orderDelivery: `${apiUrl}/api/orderDelivery`, // 订单配送
  orderRemark: `${apiUrl}/api/orderRemark`, // 订单备注
  changeOrderCost: `${apiUrl}/api/changeOrderCost`, // 修改订单费用
  getOrderExpress: `${apiUrl}/api/order/OrderLogistics/{id}`, // 获取订单物流信息

  // express
  beasExpressTemplate: `${apiUrl}/api/fareTemplate`, // 物流模版
  getTemplatePage: `${apiUrl}/api/fareTemplate/query`, // 物流模版
  getExpressList: `${apiUrl}/api/expressInfo/List`, // 获取快递公司列表
  expressTemplateDetail: `${apiUrl}/api/fareTemplate/{id}`, // 快递详情
  getExpressTemplateList: `${apiUrl}/api/fareTemplate/allList`, // 获取快递模版列表
  // 体检订单
  getCheckupOrderPage: `${apiUrl}/api/reserveOrder/query`, // 获取订单列表
  onInvalidOrder: `${apiUrl}/api/reserveOrder/Invalid`, // 订单失效
  changeReserve: `${apiUrl}/api/reserveOrder/changeReserve`, // 修改预约时间
  getOrderDetail: `${apiUrl}/api/reserveOrder/{id}`, // 获取订单详情
  // 分销
  baseDistributionGoods: `${apiUrl}/api/DistributionGoods`, // 新增/编辑分销商品
  getDistributionGoodsDetail: `${apiUrl}/api/DistributionGoods/{id}`, // 获取分销商品详情
  getDistributionGoodsPage: `${apiUrl}/api/DistributionGoods/query`, // 获取分销商品分页列表
  getDistributionMarket: `${apiUrl}/api/DistributionGoods/queryMarket`, // 获取分销卖场数据列表
  disGoodsOnOffshelf: `${apiUrl}/api/DistributionGoods/DisGoodsOnOffshelf/{id}`, // 分销商品上下架
  getGoodsDistribution: `${apiUrl}/api/goodsSPU/Distribution/{id}`, // 获取获取分销商品详情
  getDistGoodsPrice: `${apiUrl}/api/goodsSPU/queryDistGoodsPrice`, // 根据sku获取价格
  // 代理
  getAgencyoodsPage: `${apiUrl}/api/PurchaseGoods/query`, // 获取代理商品列表
  addAgencyGoods: `${apiUrl}/api/PurchaseGoods`, // 新增采购商品
  agencyGoodsOnOffshelf: `${apiUrl}/api/PurchaseGoods/OnOffshelf/{id}`, // 代理商品上下架
  // 店铺
  getShopDetail: `${apiUrl}/api/shopdiy/mydiy`, // 获取店铺详情
  addOrModify: `${apiUrl}/api/shopdiy/addOrModify`, // 新增店铺
  // 客户管理
  getMemberList: `${apiUrl}/api/member/query`, //获取会员分页数据列表
  getMemberDetail: `${apiUrl}/api/member/{id}`, //获取会员实体类
  memberAddTags: `${apiUrl}/api/member/addTags`, //为会员添加标签
  addToBlack: `${apiUrl}/api/member/addToBlack`, //加入黑名单
  memberOneAddTag: `${apiUrl}/api/member/tag`, //为单个会员添加标签
  removeFromBlack: `${apiUrl}/api/member/removeFromBlack`, //移出黑名单
  // 客户等级
  addAndUpdLeval: `${apiUrl}/api/memberLeval`, //新增或更新会员等级
  getAndDelLeval: `${apiUrl}/api/memberLeval/{id}`, //获取或删除会员等级
  levalList: `${apiUrl}/api/memberLeval/list`, //获取会员等级数据列表 --不分页
  levalPagingList: `${apiUrl}/api/memberLeval/query`, //获取会员等级分页数据列表
  // 客户标签
  addAndUpdTag: `${apiUrl}/api/membertag`, //添加会员标签-编辑会员标签
  getAndDelTag: `${apiUrl}/api/membertag/{id}`, //删除会员标签
  tagPagingList: `${apiUrl}/api/membertag/query`, //获取会员标签类别
  tagList: `${apiUrl}/api/membertag/list`, //获取会员标签类别

  // 新保云平台服务
  skcServerPageList: `${apiUrl}/api/skcServer/versions`, //分页查询新保云平台服务详情
  getSkcServer: `${apiUrl}/api/skcServer/{id}`, //获取新保云平台服务详情

  // 下单平台服务
  skcServerOrder: `${apiUrl}/api/skcServerOrder`, //服务下单
  skcServerOrderPageList: `${apiUrl}/api/skcServerOrder/myorders`, //分页查询服务订单
  skcServerOrderConfirm: `${apiUrl}/api/skcServerOrder/confirm`, //确认服务订单(Native扫码支付)
  getSkcServerOrder: `${apiUrl}/api/skcServerOrder/{id}`, //获取服务订单详情
  getPayResult: `${apiUrl}/api/skcServerOrder/payResult/{id}`, //获取订单支付结果
  cancelOrder: `${apiUrl}/api/skcServerOrder/cancel`, //取消服务下单
  offlinePay: `${apiUrl}/api/skcServerOrder/offlinePay`, //线下付款
  offlinePayAudit: `${apiUrl}/api/skcServerOrder/offlinePayAudit`, //线下付款审核
};
